// The company switcher's pieces (APP-DESIGN.md 5): each company's initial tile and colour, the
// company count under the current name, and the bank lines to review shown on Banking.

export const initial = (name: string) => (name.trim()[0] ?? 'M').toUpperCase();

/** Six colours that all carry white text. A company keeps its colour: it follows from its id. */
const COLORS = ['#eb6834', '#1b8f66', '#6250d6', '#c2457a', '#2a78d6', '#0b7a70'];
export const businessColor = (id: string) => COLORS[parseInt(id.replace(/-/g, '').slice(0, 6), 16) % COLORS.length] as string;

/** "4 companies" under the company name in the switcher. */
export const companiesLabel = (n: number) => `${n} ${n === 1 ? 'company' : 'companies'}`;

/** Bank lines still to review across every account. */
export const linesToReview = (accounts: readonly { unmatched_count?: string | null }[]) =>
  accounts.reduce((n, a) => n + (Number(a.unmatched_count ?? 0) || 0), 0);
